<template>
  <OTModal :show-modal="showModal" content-padding="10px" mobile-padding="10px">
    <template #content>
      <div class="error-modal-content">
        <img src="../assets/images/error-popup.png" alt="Error" />
        <p class="error-modal-message">
          {{ errorMessage }}
        </p>
      </div>
    </template>
    <template #actions>
      <div class="error-modal-actions">
        <OTButton @click="closeModal">{{ primaryActionText }}</OTButton>
        <OTButton v-if="secondaryAction" @click="executeSecondaryAction">{{
          secondaryAction.text
        }}</OTButton>
      </div>
    </template>
  </OTModal>
</template>

<script setup>
import { inject, watch } from "vue";
import OTModal from "./OTModal.vue";
import OTButton from "./OTButton.vue";

const audioManager = inject("audioManager");

const props = defineProps({
  showModal: {
    type: Boolean,
    required: true,
  },
  errorMessage: {
    type: String,
    required: true,
  },
  secondaryAction: {
    type: Object,
    required: false,
  },
  primaryActionText: {
    type: String,
    default: "Got it!",
  },
});

watch(
  () => props.showModal,
  (newVal) => {
    if (newVal) {
      audioManager.play("howdy");
    }
  }
);
const emit = defineEmits(["closeModal"]);
const closeModal = () => {
  emit("closeModal");
};
const executeSecondaryAction = () => {
  props.secondaryAction.action();
  closeModal();
};
</script>
<style scoped lang="scss">
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.error-modal-actions {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px;
  padding: 20px;
  width: 100%;
}
.error-modal-content {
  position: relative;
  .error-modal-message {
    text-align: left;
    position: absolute;
    font-size: 24px;
    top: 4%;
    right: 5%;
    width: 38%;
  }
}
@media (max-width: 768px) {
  .error-modal-content {
    .error-modal-message {
      top: 2%;
      font-size: 14px;
    }
  }
}
</style>
